import { useState, useEffect } from "react";
import "./locationSearchBar.scss";
import useFetch from "../../useFech";
import { ImLocation } from "react-icons/im";
import { useDispatch, useSelector } from "react-redux";
import jwt_decode from "jwt-decode";

function LocationSearchBar(props) {
  const { autofocusProp, setInputAddressLabel } = props;
  const locationSeleced = useSelector((state) => state.userReducer);
  const [message, setMessage] = useState(
    JSON.parse(localStorage.getItem("inputAddressLabel")) || ""
  );
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);

  const token = localStorage.getItem("token");
  useEffect(() => {
    // This effect will run whenever locationSeleced or storedState changes
    console.log("Effect started");

    if (token === null) {
      setMessage(JSON.parse(localStorage.getItem("inputAddressLabel")) || "");
      console.log(locationSeleced.address);
      if (locationSeleced.address.label !== "") {
        localStorage.setItem(
          "location",
          JSON.stringify(locationSeleced.address)
        );
      }
    } else {
      const decodedToken = jwt_decode(token);
      if (
        decodedToken.address.label !== locationSeleced.address.label &&
        locationSeleced.address.label !== ""
      ) {
        setMessage(JSON.parse(localStorage.getItem("inputAddressLabel")) || "");
        console.log(decodedToken.address.label);
      } else {
        setMessage(decodedToken.address.label);
        localStorage.setItem("location", JSON.stringify(decodedToken.address));
      }
    }
    console.log("Effect completed");
  }, [locationSeleced, token]);

  var locationsFound = [];
  var allInfoLocationsFound = [];
  const clickedLocation = (event) => {
    const token = localStorage.getItem("token");
    const location = allInfoLocationsFound[event.target.id];

    console.log({ location });
    const keysToCheck = ["city", "housenumber", "label", "postcode", "street"];
    const emptyProperties = keysToCheck.filter((key) => !location[key]);
    if (emptyProperties.length === 0) {
      localStorage.setItem("inputAddressLabel", JSON.stringify(location.label));
      localStorage.setItem("location", JSON.stringify(location));

      console.log(typeof setInputAddressLabel);
      if (typeof setInputAddressLabel === "function") {
        setInputAddressLabel(location);
      }
      dispatch({
        type: "HANDLECHANGE",
        payload: {
          location: location,
        },
      });
      setErrorMessage("");
      if (token) {
        const decodedToken = jwt_decode(token);
        const addressFromLocalStorage = JSON.parse(
          localStorage.getItem("inputAddressLabel")
        );
        if (
          decodedToken.address.label !== addressFromLocalStorage &&
          addressFromLocalStorage !== ""
        ) {
          const isConfirmed = window.confirm(
            `Do you want to order from this address?\n${location.label}`
          );

          if (isConfirmed) {
            localStorage.setItem("location", JSON.stringify(location));
            localStorage.setItem(
              "inputAddressLabel",
              JSON.stringify(location.label)
            );
            setMessage(location.label);
            console.log("address confirmed!");
          } else {
            localStorage.setItem(
              "inputAddressLabel",
              JSON.stringify(decodedToken.address.label)
            );
            localStorage.setItem(
              "location",
              JSON.stringify(decodedToken.address)
            );
            setMessage(decodedToken.address.label);
            console.log("address canceled or closed.");
          }
        }
      }
    } else {
      setErrorMessage(`${emptyProperties.join(", ")}. is required `);
    }
    setMessage(allInfoLocationsFound[event.target.id].label);
    setVisible(false);
  };
  useEffect(() => {
    const inputElement = document.querySelector("input");
    inputElement.value = message;
  }, [message]);

  const visibilityLocations = () => {
    setVisible(true);
  };
  const handleChange = (event) => {
    setMessage(event.target.value);
    setVisible(true);
  };

  const { data } = useFetch(
    "https://api-adresse.data.gouv.fr/search/?q=" + message
  );

  for (var i = 0; i < 5; i++) {
    locationsFound.push(
      <label
        key={i}
        id={i}
        onClick={clickedLocation}
        style={{ display: visible ? "block" : "none" }}
      >
        {data?.features[i]?.properties?.label}
      </label>
    );
    allInfoLocationsFound.push(data?.features[i]?.properties);
  }

  if (message < 3 && locationsFound.length === 5) {
    while (locationsFound.length) {
      locationsFound.pop();
    }
  }
  const handlePageClick = (event) => {
    if (visible && !event.target.closest(".locations_search_span")) {
      setVisible(false);
    }
  };

  window.addEventListener("click", handlePageClick);

  return (
    <>
      <div className="locationsSearch">
        <p className="location_icon">
          <ImLocation />
        </p>
        <input
          autoFocus={autofocusProp}
          className="navbar-address-input"
          id="navbar-address"
          type="text"
          defaultValue={message}
          onChange={handleChange}
          placeholder=" Your address: E.g. 2 rue des Mimosas, 75000 Pays-Fictif"
          onClick={visibilityLocations}
          required
        />
        {/* <div className="locations_search_span">{locationsFound}</div> */}
        <div className="locations_search_span">
          {visible && locationsFound.length > 0 ? (
            <div className="locations_search_dropdown">
              {locationsFound.map((item, index) => (
                <div
                  key={index}
                  onClick={clickedLocation}
                  className="locations_search_item"
                >
                  {item}
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
      {errorMessage && (
        <div style={{ color: "red" }} className="locations_search_error">
          {errorMessage}
        </div>
      )}
    </>
  );
}

export default LocationSearchBar;
